// Hook: POST /company/departments

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IRequest {
  location_id: number;
  name: string;
  short_name?: string | null;
  manager_user_id?: number | null;
  deputy_manager_user_id?: number | null;
  limit_enabled?: boolean;
  limit_period?: 'm' | 'q' | 'y' | null;
  limit_amount?: string | null;
  limit_visible_to_user?: boolean;
}

type IResponse = ICommandResponseSuccess;

const postCompanyDepartment = (data: IRequest): Promise<IResponse> =>
  axios.post('/company/departments', data);

export const usePostCompanyDepartment = (
  options?: UseMutationOptions<IResponse, IError, IRequest>
) => useMutation((data: IRequest) => postCompanyDepartment(data), options);
